import clsx from 'clsx';
import styles from './CroppedImage.module.css';

type CroppedImageProps = {
  src: string;
  srcSet: string;
  dataTestId: string;
  height?: number;
  alt?: string;
  className?: string;
  /**
   * Defines where the scaling of the image should be focused.
   */
  objectPosition?: 'left top' | 'center center' | 'center top';
  noBottomRadius?: boolean;
};

const CroppedImage = ({
  src,
  srcSet,
  height = 300,
  alt,
  dataTestId,
  className,
  objectPosition = 'center center',
  noBottomRadius = false,
}: CroppedImageProps) => (
  <div
    className={clsx(styles.container, {
      [styles.noBottomRadius]: noBottomRadius,
    })}
    style={{ height: `${height}px` }}
    data-testid={dataTestId}
  >
    <img
      src={src}
      srcSet={srcSet}
      alt={alt ?? ''}
      className={clsx(styles.image, className)}
      style={{ objectPosition }}
      data-testid={`${dataTestId}-img`}
    />
  </div>
);

export default CroppedImage;
